import { Form, Formik, FormikHelpers, FormikProps } from 'formik';
import { Container, Row, Col } from 'react-bootstrap';
import { OATextField } from '../../../components/fields';
import OAButton from '../../../components/widgets/OAButton';
import * as Yup from 'yup';
import { useContext, useState } from 'react';
import LedgerContext from '../context/LedgerContext';

interface ITopupFormModal {
  onHide: () => void;
  onSuccess?: () => void;
}

const init = {
  amount: '',
  paymentMethod: '',
  referenceId: '',
  settlementDate: '',
  settlementTime: '',
  bank: '',
  accountNumber: '',
  ifsc: ''
};

const TopupSchema = Yup.object().shape({
  amount: Yup.number().positive().required('Please enter amount').min(1),
  paymentMethod: Yup.string().required('Payment Method is required'),
  referenceId: Yup.string().required('Reference ID is required'),
  settlementDate: Yup.string().required('Settlement Date is required'),
  settlementTime: Yup.string().required('Settlement Time is required'),
  bank: Yup.string(),
  accountNumber: Yup.string(),
  ifsc: Yup.string()
});

export default function AddTopupForm(props: ITopupFormModal) {
  const { addTopup } = useContext(LedgerContext);
  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = (values: any, actions: FormikHelpers<any>) => {
    setLoading(true);

    // Combine date and time from user input
    const dateTime = new Date(values.settlementDate + 'T' + values.settlementTime);

    // Format the request body according to API spec
    const requestBody: any = {
      amount: parseFloat(values.amount),
      paymentMethod: values.paymentMethod,
      referenceId: values.referenceId,
      settlementDate: dateTime.toISOString()
    };

    // Add metadata only if any of its fields are provided
    if (values.bank || values.accountNumber || values.ifsc) {
      requestBody.metadata = {};
      if (values.bank) requestBody.metadata.bank = values.bank;
      if (values.accountNumber) requestBody.metadata.accountNumber = values.accountNumber;
      if (values.ifsc) requestBody.metadata.ifsc = values.ifsc;
    }

    addTopup(requestBody, (res: any) => {
      setLoading(false);
      if (res?.data?.success) {
        actions.resetForm();
        props?.onSuccess?.();
      }
      props?.onHide();
    });
  };

  return (
    <Formik
      initialValues={init}
      onSubmit={handleSubmit}
      validationSchema={TopupSchema}
      enableReinitialize>
      {(formikProps: FormikProps<any>) => {
        return (
          <Container fluid as={Form} className='p-0'>
            <Row className='mb-4'>
              <Col lg={4}>
                <OATextField name='amount' label='Amount' type='number' required />
              </Col>
              <Col lg={4}>
                <OATextField name='settlementDate' label='Settlement Date' type='date' required />
              </Col>
              <Col lg={4}>
                <OATextField name='settlementTime' label='Settlement Time' type='time' required />
              </Col>
            </Row>

            <Row className='mb-4'>
              <Col lg={6}>
                <OATextField name='paymentMethod' label='Payment Method' required />
              </Col>
              <Col lg={6}>
                <OATextField name='referenceId' label='Reference ID' required />
              </Col>
            </Row>

            <Row className='mb-4'>
              <Col lg={12}>
                <h6 className='mb-3'>Metadata (Optional)</h6>
              </Col>
              <Col lg={4}>
                <OATextField name='bank' label='Bank' />
              </Col>
              <Col lg={4}>
                <OATextField name='accountNumber' label='Account Number' />
              </Col>
              <Col lg={4}>
                <OATextField name='ifsc' label='IFSC Code' />
              </Col>
            </Row>

            <div className='d-flex justify-content-end mt-5'>
              <OAButton
                className='btn-light-primary btn-active-light-primary me-3'
                label='Cancel'
                onClick={() => {
                  formikProps?.resetForm();
                  props?.onHide();
                }}
              />
              <OAButton
                type='submit'
                disabled={!formikProps?.dirty || !formikProps?.isValid}
                isLoading={loading}
                loadingText='Adding Topup...'
                label='Add Topup'
              />
            </div>
          </Container>
        );
      }}
    </Formik>
  );
}